/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import { number, string, oneOfType } from 'prop-types';
import React from 'react';

import { Dollar } from 'components/shared/Text/Text';

const DollarCell = ({ amount, className }) => {
  if (amount === '-') {
    return <td className={className}>{amount}</td>;
  }
  return (
    <td className={className}>
      <Dollar>{amount}</Dollar>
    </td>
  );
};

DollarCell.propTypes = {
  amount: oneOfType([number, string]).isRequired,
  className: string.isRequired
};

DollarCell.defaultProps = {
  className: ''
};

export default DollarCell;
